export default __webpack_public_path__ + "static/media/snoonu.1b5f7fc8.png";